// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XYyc3","label":"styles_label__2Jxwl"};